import { connect } from 'react-redux';

import { getPermissions, getUser } from '../../Login/selectors';
import {
  setSelectedRole,
  toggleNewRole,
  updateChecks,
  updateRoleName,
} from '../actions';
import {
  createRoleActionSagas,
  deleteRoleActionSagas,
  editRoleActionSagas,
  getActionsActionSagas,
  getAllRolesActionSagas,
  getPagesActionSagas,
} from '../actionsSagas';
import {
  getAllRoles,
  getChecks,
  getIsLoading,
  getNewRoleMode,
  getPages,
  getRoleName,
  getSelectedRole,
  getWorkFLowActions,
  isCreating,
  isDeleting,
  isUpdating,
} from '../selectors';
import Roles from './Roles';

const mapStateToProps = (state) => ({
  roles: getAllRoles(state),
  pages: getPages(state),
  actions: getWorkFLowActions(state),
  creating: isCreating(state),
  updating: isUpdating(state),
  deleting: isDeleting(state),
  selectedRole: getSelectedRole(state),
  roleName: getRoleName(state),
  checks: getChecks(state),
  newRoleMode: getNewRoleMode(state),
  loggedUser: getUser(state),
  permissions: getPermissions(state),
  isLoading: getIsLoading(state),
});

const mapDispatchToProps = (dispatch) => ({
  loadRoles: () => dispatch(getAllRolesActionSagas()),
  loadPages: () => dispatch(getPagesActionSagas()),
  loadActions: () => dispatch(getActionsActionSagas()),
  createRole: (role) => dispatch(createRoleActionSagas(role)),
  updateRole: (role) => dispatch(editRoleActionSagas(role)),
  deleteRole: (role) => dispatch(deleteRoleActionSagas(role)),
  setSelectedRole: (role) => dispatch(setSelectedRole(role)),
  updateRoleName: (name) => dispatch(updateRoleName(name)),
  updateChecks: (checks) => dispatch(updateChecks(checks)),
  toggleNewRole: (role) => dispatch(toggleNewRole(role)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Roles);
